import React from "react";
import "./FeatureDetails.scss";

const FeaturePlan = ({ featureplan }) => {
  const filterValue = (value) => {
    if (value?.includes("All"))
      return "All";
    else return value.join(", ")
  }
  return (
    <>
      {(featureplan[0] == "DASHBOARD" && featureplan[1]?.length > 0) && <div className="feature-plan"> <p >Dashboard <span>{filterValue(featureplan[1])}</span></p> </div>}
      {(featureplan[0] == "TIMESHEET" && featureplan[1]?.length > 0) && <div className="feature-plan"> <p >AI Features <span>{filterValue(featureplan[1])}</span></p></div>}
      {(featureplan[0] == "REPORT" && featureplan[1]?.length > 0) && <div className="feature-plan"> <p>Report <span>{filterValue(featureplan[1])}</span></p></div>}
      {(featureplan[0] == "INTEGRATION" && featureplan[1]?.length > 0) && <div className="feature-plan"> <p>Integration <span>{filterValue(featureplan[1])}</span></p></div>}
      {(featureplan[0] == "OTHERS" && featureplan[1]?.length > 0) && <div className="feature-plan"> <p>Others <span>{filterValue(featureplan[1])}</span></p></div>}
      {(featureplan[0] == "PROJECT_COUNT" && featureplan[1]?.length > 0) && <div className="feature-plan"> <p>Project count <span>{filterValue(featureplan[1])}</span></p></div>}
      {(featureplan[0] == "MEMBER_COUNT" && featureplan[1]?.length > 0) && <div className="feature-plan"><p>Member count<span>{filterValue(featureplan[1])}</span></p></div>}
      {(featureplan[0] == "TAG_COUNT" && featureplan[1]?.length > 0) && <div className="feature-plan"><p>Tag count <span>{filterValue(featureplan[1])}</span></p></div>}
      {(featureplan[0] == "DAILY_AI_SUMMARIZATION_LIMITS" && featureplan[1]?.length > 0) && <div className="feature-plan"> <p>Daily AI summarizations<span>{filterValue(featureplan[1])}</span></p></div>}
    </>
  );
};

const FeatureDetails = ({ featureplans }) => {
  return (
    <div className="feature-details">
      <h2 className="feature-title">Feature details</h2>
      {Object.entries(featureplans).map((featureplan, index) => (
        <FeaturePlan key={index} featureplan={featureplan} />
      ))}
    </div>
  );
};

export default FeatureDetails;
